import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { firstValueFrom, interval, Subject, takeUntil, timer } from 'rxjs';
import { TabRole, TabsService } from 'src/app/libs/components/tabs-host/tabs.service';
import { AdminDocumentTypesEditComponent } from 'src/app/routes/admin/admin-document-types/admin-document-types-edit/admin-document-types-edit.component';
import { MasterApiService } from 'src/app/services/master-api.service';

@Component({
    selector: 'app-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.sass'],
    standalone: false
})
export class TestComponent implements OnInit, OnDestroy {
  
  destroy$ = new Subject<void>();
  ready: boolean = false;
  form: FormGroup;

  constructor(private api: MasterApiService, private fb: FormBuilder, private tabs: TabsService) {
    this.form = this.fb.group({
      time: [new Date('1970-01-01T12:23:00')],
    });
  }

  async ngOnInit(): Promise<void> {
    this.ready = true;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
